var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.03 22.0065V14.6792C22.03 11.0785 21.2556 8.32685 17.0535 8.32685C16.2647 8.294 15.4818 8.47684 14.7892 8.85571C14.0966 9.23458 13.5203 9.79514 13.1225 10.4771H13.0734V8.65116H9.1012V22.0065H13.2522V15.3789C13.2522 13.6277 13.5766 11.9531 15.7287 11.9531C17.8809 11.9531 17.8789 13.9284 17.8789 15.4792V21.9809H22.03V22.0065Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34786 8.65311H6.49891V22.0084H2.34786V8.65311Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42535 2.00003C3.94699 1.9977 3.47873 2.13756 3.08002 2.40187C2.6813 2.66618 2.37012 3.04301 2.18598 3.48451C2.00184 3.92602 1.95305 4.41228 2.04581 4.88157C2.13856 5.35085 2.36867 5.782 2.70693 6.12025C3.04518 6.4585 3.47632 6.68862 3.9456 6.78137C4.41489 6.87412 4.90116 6.82533 5.34266 6.64119C5.78416 6.45705 6.16099 6.14587 6.4253 5.74716C6.68961 5.34844 6.82948 4.88018 6.82715 4.40182C6.82715 3.76483 6.5741 3.15392 6.12368 2.7035C5.67325 2.25307 5.06235 2.00003 4.42535 2.00003Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.e77db86d574d874ac47457cb9a27d29c.svg";
export { ForwardRef as ReactComponent };